var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$route.hash === '#renting-entity' || _vm.$route.hash === '')?_c('div',[_vm._v(" RentingEntityDocumentation ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }